import { OBPSService } from "../../services/elements/OBPS";
import { useMutation } from "react-query";

const updateNOCAPI = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateNOC(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};

const updateAPI = async (data, tenantId) => {
  try {
    const response = await OBPSService.update(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};
const updateRegistration = async (data, tenantId) => {
  try {
    const response = await OBPSService.BPAREGupdate(data, tenantId);
    return response;
  } catch (error) {
    throw  error.response?.data?.message || new Error(error?.response?.data?.Errors[0].code) || "Something went wrong!";
  }
};
const updateOwnerRegistration = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateOwner(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};
const updatePurchasableFarRegistration = async (data, tenantId) => {
  try {
    const response = await OBPSService.updatePurchasableFAR(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(JSON.stringify(error?.response?.data?.Errors[0])); // Custom Errors to be displayed for FAR
  }
};

const updateForm11API = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateForm11(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};
const updateFormCluApi = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateFormCLU(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};
const updateForm34Api = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateForm34(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};
const updateFormLandUseApi = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateFormLandUse(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};
const updateNOC = async (data, tenantId) => {
  try {
    const response = await OBPSService.updateNOC(data, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].code);
  }
};

const useObpsAPI = (tenantId, type = false) => {
  if (type) {
    if (["Form11", "Form26"].includes(type)) {
      return useMutation((data) => updateForm11API(data, tenantId));
    }
    if (type === "FormCLU") {
      return useMutation((data) => updateFormCluApi(data, tenantId));
    }
    if (type === "Form34") {
      return useMutation((data) => updateForm34Api(data, tenantId));
    }
    if (type === "Registration") {
      return useMutation((data) => updateRegistration(data, tenantId));
    }
    if (type === "OWNER_REGISTRATION") {
      return useMutation((data) => updateOwnerRegistration(data, tenantId));
    }
    if (type === "PURCHASABLE_FAR") {
      return useMutation((data) => updatePurchasableFarRegistration(data, tenantId));
    }
    if (type === "FORMLANDUSE") {
      return useMutation((data) => updateFormLandUseApi(data, tenantId));
    }
    if (type === "NOC") {
      return useMutation((data) => updateNOC(data, tenantId));
    }
    return useMutation((data) => updateNOCAPI(data, tenantId));
  } else {
    return useMutation((data) => updateAPI(data, tenantId));
  }
};

export default useObpsAPI;
